import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiOpportunitService } from 'src/app/services/ApiOpportunite/api-opportunite.service';
import { Store } from '@ngrx/store';
import { DetailsOpportuniteStore } from '../../store/details-opportunite.reducers';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.css'],
})
export class DetailsComponent implements OnInit {
  selectedTabIndex = 0;

  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit() {
    // Listen to route changes and update tab index accordingly
    this.route.firstChild?.url.subscribe((urlSegments) => {
      const path = urlSegments[0]?.path; // e.g. 'contrat-actuel'
      if (path === 'contrat-actuel') {
        this.selectedTabIndex = 0;
      } else if (path === 'information-complementaires') {
        this.selectedTabIndex = 1;
      } else if (path === 'information-specifiques') {
        this.selectedTabIndex = 2;
      }
    });
  }

  onTabChange(index: number) {
    switch (index) {
      case 0:
        this.router.navigate(['contrat-actuel'], { relativeTo: this.route });
        break;
      case 1:
        this.router.navigate(['information-complementaires'], {
          relativeTo: this.route,
        });
        break;
      case 2:
        this.router.navigate(['information-specifiques'], {
          relativeTo: this.route,
        });
        break;
    }
  }
}
